const Header = () => {
    return (
        <>
            <h1>Affirm <br/> 
            <span className='titleStyles'>Believe</span>
            <br/> Recieve</h1>

            <p className='headerTxt'>Affirmations are positive statements that can help you overcome negative thinking and self-sabotaging beliefs. Use them to manifest goals, dreams or anything your heart desires. Enter your favourite affirmations below, and repeat daily!</p>
            <div className='backgroundAura'></div>
        
        </>

    )
}

export default Header;